import { render, staticRenderFns } from "./ContextSettings.Context.vue?vue&type=template&id=caafa770&scoped=true&"
import script from "./ContextSettings.Context.vue?vue&type=script&lang=ts&"
export * from "./ContextSettings.Context.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettings.Context.vue?vue&type=style&index=0&id=caafa770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caafa770",
  null
  
)

export default component.exports